export default "__VITE_ASSET__86541849__"